import * as React from 'react';
type Props = {
  className?: string;
};
export function Play({ className }: Props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="utility-play"
      className={className}
    >
      <path
        d="M18.525 11.6559L9.52 6.14719C9.36818 6.05422 9.19429 6.00347 9.0163 6.00017C8.83831 5.99688 8.66266 6.04115 8.5075 6.12844C8.35382 6.21436 8.2258 6.33967 8.1366 6.49148C8.04741 6.64329 8.00026 6.81612 8 6.99219V18.0084C8.00116 18.2726 8.10715 18.5254 8.29466 18.7114C8.48218 18.8974 8.73589 19.0013 9 19.0003C9.18435 19.0002 9.36511 18.9494 9.5225 18.8534L18.525 13.3447C18.6697 13.2565 18.7893 13.1326 18.8723 12.9848C18.9553 12.837 18.9989 12.6704 18.9989 12.5009C18.9989 12.3315 18.9553 12.1648 18.8723 12.0171C18.7893 11.8693 18.6697 11.7454 18.525 11.6572V11.6559Z"
        fill="currentColor"
      />
    </svg>
  );
}
